var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CardFlip from "notifications/ui/CardFlip";
import { CardBody } from "../../molecules/CardBody";
import { CardFooter } from "../../molecules/CardFooter";
import { CardHeader } from "../../molecules/CardHeader";
import { AccountCardContainer, DesktopCardContainer, } from "./DesktopCard.styles";
import NotificationCard from "../NotificationCard/NotificationCard";
import CardBack from "../CardBack/CardBack";
var DesktopCard = function (_a) {
    var notificationList = _a.notificationList, _b = _a.cardData, footerData = _b.footerData, headerData = _b.headerData, bodyData = _b.bodyData, isFlipped = _a.isFlipped, setIsFlipped = _a.setIsFlipped;
    var hasAuthOverlay = bodyData.isOverlay;
    var isLoanPaidOffForSI = bodyData === null || bodyData === void 0 ? void 0 : bodyData.isLoanPaidOffForSI;
    var isLoanPaidOff = bodyData === null || bodyData === void 0 ? void 0 : bodyData.isLoanPaidOff;
    var isNotificationVisible = !hasAuthOverlay && !isLoanPaidOffForSI && !isLoanPaidOff;
    return (_jsx(AccountCardContainer, { children: _jsxs(CardFlip, __assign({ isFlipped: isFlipped }, { children: [_jsxs(DesktopCardContainer, __assign({ "data-testid": "desktop-card-container" }, { children: [_jsx(CardHeader, __assign({}, headerData, { notificationList: notificationList })), !notificationList ||
                            (isNotificationVisible && (_jsx(NotificationCard, { notificationList: notificationList, handleOnClick: function () { return setIsFlipped(!isFlipped); } }))), _jsx(CardBody, { bodyData: bodyData }), _jsx(CardFooter, __assign({}, footerData))] })), _jsxs(DesktopCardContainer, { children: [_jsx(CardHeader, __assign({}, headerData)), _jsx(CardBack, { "data-test": "vertical-card-back", setIsFlipped: setIsFlipped, notificationList: notificationList !== null && notificationList !== void 0 ? notificationList : [] })] })] })) }));
};
export default DesktopCard;
//# sourceMappingURL=DesktopCard.js.map